// extracted by mini-css-extract-plugin
module.exports = {"skip_link":"SkipLink_skip_link__0Rmg2","spin":"SkipLink_spin__OgX8L"};